interface ISundryMessagesMultipleDeliveries {
  totalVehicles: number;
  numberOfSundries: number;
}

export default function sundryMessagesMultipleDeliveries({
  totalVehicles,
  numberOfSundries,
}: ISundryMessagesMultipleDeliveries): string {
  const defaultEnding =
    "vehicle invoices are paid, this delivery request will be generated as a Sundry invoice";

  let prefix = "";

  if (numberOfSundries === totalVehicles) {
    prefix = "All";
  } else {
    prefix = `${numberOfSundries} of ${totalVehicles}`;
  }

  return `${prefix} ${defaultEnding}`;
}
